// src/utils/request.js
import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store' // 引入vuex store，用于获取token等状态
import router from '@/router'
import dayjs from 'dayjs'
import md5 from 'md5';
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // 从环境变量获取基础请求地址
  //baseURL: '/api', // 测试环境可直接写相对路径
  timeout: 5000, // 请求超时时间10秒
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送前做统一处理
    const token = store.state.Token.token
    if (token) {
      config.headers['Authorization'] = store.state.Token.token // 携带token
    }
    config.params.time=dayjs().unix()
    let encryptedString =''
    for(let prop in config.params){
        encryptedString+=md5(config.params[prop].toString())
        //	console.log('config.params',config.params[prop]);
    }
    encryptedString=md5("service"+encryptedString);
    config.params.legality=encryptedString
    config.params.app_version='1.0.3'
   // console.log('time:', dayjs().unix())
    return config
  },
  error => {
    console.log('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 根据接口返回状态码判断请求是否成功
     if (res.code === 500&&(typeof res.data === "string")&&(res.data.includes("token"))) {
        router.push({
          path: '/login',
          //query: { redirect: router.currentRoute.fullPath }
        });
        return Promise.reject(new Error(res.message || res.data))
     }
     else{
        return res
     }  
    // } else {
    //   Message.error(res.message || '请求失败')
    //   return Promise.reject(new Error(res.message || '请求失败'))
    // }
  },
  error => {
    console.log('响应拦截器错误:', error)
    Message.error(error.message || '网络异常')
    return Promise.reject(error)
  }
)

// 封装常用请求方法
export default {
  // get请求
  get(url, params = {}) {
    return service({
      url,
      method: 'get',
      params
    })
  },
  // post请求
  post(url, params = {},data = {}) {
    return service({
      url,
      method: 'post',
      data,
      params
    })
  },
  // put请求
  put(url, data = {}) {
    return service({
      url,
      method: 'put',
      data
    })
  },
  // delete请求
  delete(url, params = {}) {
    return service({
      url,
      method: 'delete',
      params
    })
  }
}
